/** Shared formatters for quotes and invoices tables. */

export const formatBillingAmount = (amount) => {
    const value = Number(amount);
    if (Number.isNaN(value)) return '—';
    return `$${value.toFixed(2)}`;
};

export const formatBillingDate = (value) => {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString();
};

export const formatBillingDateTime = (value) => {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleString();
};

export const formatInvoiceStatus = (status) => {
    if (!status) return '—';
    if (String(status).toLowerCase() === 'open') return 'Unpaid';
    return status;
};
